export enum NotificationClass {
  COMPUTED = 'COMPUTED',
  NORMAL = 'NORMAL',
}
